import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSomeone = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 9.8504,
			cy: 5.98224,
			rx: 4.03107,
			ry: 4.03107,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 9.85027,
			cy: 17.0672,
			rx: 7.05437,
			ry: 4.03107,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9407 17.0674C21.9407 18.7372 19.8893 20.0907 17.3847 20.0907C18.1226 19.2842 18.63 18.2718 18.63 17.0689C18.63 15.8645 18.1215 14.8512 17.3822 14.0442C19.8868 14.0442 21.9407 15.3977 21.9407 17.0674Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9174 5.98229C18.9174 7.65201 17.5638 9.00559 15.8941 9.00559C15.53 9.00559 15.1809 8.94123 14.8577 8.82326C15.3344 7.98471 15.6067 7.01473 15.6067 5.98116C15.6067 4.94835 15.3348 3.97905 14.8587 3.14092C15.1817 3.0232 15.5304 2.95898 15.8941 2.95898C17.5638 2.95898 18.9174 4.31256 18.9174 5.98229Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgSomeone);
export default ForwardRef;
